import CheckBoxRoundedIcon from "@mui/icons-material/CheckBoxRounded";
import IndeterminateCheckBoxRoundedIcon from "@mui/icons-material/IndeterminateCheckBoxRounded";
import { Checkbox, Divider, Paper, Stack, Typography } from "@mui/material";
import { CustomToolbarActions } from "../../report-lists/reports/grid/CustomToolbarActions";
import type { ArtifactRow } from "./artifactRow";
import type { ArtifactActionHandlers } from "./ArtifactActions";
import { toBulkActionReport } from "./artifactBulkActions";

interface Props extends Pick<ArtifactActionHandlers, "onChangeGroup" | "onDelete"> {
  selectedRows: ArtifactRow[];
  isAllSelected: boolean;
  onClear: () => void;
}

const ArtifactTilesSelectionBar = ({ selectedRows, isAllSelected, onClear, onChangeGroup, onDelete }: Props) => (
  <Paper variant="outlined">
    <Stack
      role="toolbar"
      aria-label="Selected dashboards"
      direction="row"
      sx={{ alignItems: "center", minHeight: 38, pl: "2px", pr: 1.5 }}
    >
      <Checkbox
        checked={isAllSelected}
        indeterminate={!isAllSelected}
        checkedIcon={<CheckBoxRoundedIcon />}
        indeterminateIcon={<IndeterminateCheckBoxRoundedIcon />}
        onClick={onClear}
        slotProps={{ input: { "aria-label": "Clear selection" } }}
      />
      <Typography variant="subtitle2">{selectedRows.length} selected</Typography>
      <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 2, mr: 1 }} />
      <CustomToolbarActions
        selectedReports={selectedRows.map(toBulkActionReport)}
        onMove={(artifactIds) => onChangeGroup(artifactIds, onClear)}
        onDelete={(artifactIds) =>
          onDelete(
            selectedRows.filter((row) => artifactIds.includes(row.id)),
            onClear
          )
        }
        hideCopy
      />
    </Stack>
  </Paper>
);

export default ArtifactTilesSelectionBar;
